import React from "react";
import { Link } from "react-router-dom";

import {
  Box,
  Button,
  Divider,
  HStack,
  Spacer,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  useTab,
} from "@chakra-ui/react";
import {
  BarChart,
  Cloud,
  Bookmark,
  CornerDownLeft,
  Search,
  Settings,
} from "react-feather";
import { useCurrentProfile } from "../../ContextWrapper";
import { ResourcesCategory } from "../businessResources/resourcesCategoryAdmin";
import { InsightListing } from "../industryInsights/insightListing";
import { ClientVendorSearch } from "./clientVendorSearch";
import { GoogleFolderLink } from "./clientGoogleFolderLink";
import { ResourceVault } from "../businessResources/resourceVault";
import { ResourcesItems } from "../businessResources/resourcesItemsAdmin";
import { GeneralToolsTab } from "./generalTools";
import { TutorialItems } from "./tutorials";

export const ToolDetail = () => {
  const { profile } = useCurrentProfile();

  return (
    <Tabs
      orientation="vertical"
      isLazy
      display="flex"
      pt="80px"
      h="calc(100vh)"
      overflow="hidden"
    >
      <TabList
        border="0"
        bg="brand.1000"
        color="white"
        w="322px"
        display="flex"
        flexDirection="column"
      >
        <Divider m="0" color="gray.50" />
        <Box pl="6" pr="6" pt={"10px"} pb={"10px"}>
          <Text mb={"5px"}>Admin Tools</Text>
          <Divider color="gray.50" />
        </Box>

        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <Search />
            </Box>
            Account Vendor Search
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <BarChart />
            </Box>
            Manage Insights
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <BarChart />
            </Box>
            Manage Focus Areas
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <BarChart />
            </Box>
            Manage Resources
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <BarChart />
            </Box>
            Manage Tutorials
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <Bookmark />
            </Box>
            Lucro Vault
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <Cloud />
            </Box>
            Link Google drive folders
          </CustomTab>
        )}
        {profile?.type === "admin" && (
          <CustomTab justifyContent="stretch">
            <Box mr="2">
              <Settings />
            </Box>
            General Actions
          </CustomTab>
        )}
        <Spacer />

        <Box pl="6" pb="6" pr="6">
          <Divider color="gray.50" />
          <Text fontSize="sm" color="gray.300">
            Actions
          </Text>
          <Link to="/">
            <HStack>
              <CornerDownLeft />
              <Box>Back to Account Listing</Box>
            </HStack>
          </Link>
        </Box>
      </TabList>
      <TabPanels overflowY="auto">
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <ClientVendorSearch />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <InsightListing />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <ResourcesCategory />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <ResourcesItems />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <TutorialItems />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <ResourceVault componentOnly = {true} />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <GoogleFolderLink />
            </Box>
          </TabPanel>
        )}
        {profile?.type === "admin" && (
          <TabPanel p="0">
            <Box h="calc(100vh - 80px)">
              <GeneralToolsTab />
            </Box>
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
};

const CustomTab = React.forwardRef((props, ref) => {
  const tabProps = useTab({ ...props, ref });
  const isSelected = !!tabProps["aria-selected"];

  return (
    <Button
      w="290px"
      pt="6"
      pb="6"
      ml="4"
      mr="4"
      mt="2"
      mb="2"
      bg={isSelected ? "brand.600" : "brand.1000"}
      {...tabProps}
    >
      {tabProps.children}
    </Button>
  );
});
